export default "__VITE_ASSET__BNFEE19Y__"